import React from 'react';
import {connectHits} from 'react-instantsearch/connectors';

import HitComponent from './HitComponent';

class CustomHits extends React.Component {
  render () {
  const {searchState, hits} = this.props
  // const CustomHits = connectHits(({ hits }) => {
  //   const hs = hits.map(hit => <HitComponent key={hit.objectID} hit={hit} searchState="hello" />);
  // })
    return (
      // <div id="hits">{hs}</div>
      <div>
        {hits.map(h => <HitComponent key={h.objectID} hit={h} searchState={searchState} />)}
      </div>
    )
  }
}
const ConnectedHits = connectHits(CustomHits)

export default ConnectedHits;



// WEBPACK FOOTER //
// ./src/components/CustomHits.js